import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  .image{
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: 10px;
  }
  .name {
    width: 150px;
    height: 18px;
  }
  .linkedin {
    width: 200px;
    height: 18px;
  }
`;

const UserSocialInfoCardSkeleton = function UserSocialInfoCardSkeleton() {
  return (
    <Wrapper>
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <div className="skeleton-box image" />
        </div>
        <div>
          <div className="skeleton-box name" />
          <div className="skeleton-box linkedin" />
        </div>
      </div>
    </Wrapper>
  );
};

export default UserSocialInfoCardSkeleton;
